export const searchDocumentsTypes = ({ query, items }) => {
    return items.filter((item) => `${item.code.toLocaleLowerCase()} ${item.name.toLocaleLowerCase()}`.includes(query.toLocaleLowerCase()));
};
export const convertDocumentsTypes = (items) => {
    return items.map((item) => ({
        type: 'row',
        name: item.name,
        code: item.code,
    }));
};
export const getPopularDocumentTypes = (items) => {
    const popularDocumentTypesCodes = ['21', '10', '03', '12'];
    return popularDocumentTypesCodes.reduce((res, code) => {
        const candidate = items.find((item) => item.code === code);
        return candidate ? [...res, candidate] : res;
    }, []);
};
export const convertDocumentTypeToString = (candidate) => {
    return `${candidate.code} ${candidate.name}`.trim();
};
export const getDocumentTypeCode = (candidate) => {
    return candidate.code;
};
